import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { ANALYTICS_CONSTANTS } from 'config';
import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
declare var ENV_PORTAL;
@Injectable()
export class ContactService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  getContactDetails(getContactDetailsservice) {
    return this.httpClientService.get(getContactDetailsservice)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  // Page Load
  createPageLoadProperties(url: string, title: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_CONTACT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SUPPORT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Support'; 
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  handleError = (error) => {
    return throwError(error);
  }
}

